import { render, staticRenderFns } from "./ModuleEditProfile.vue?vue&type=template&id=93fff466&scoped=true&lang=pug&"
import script from "./ModuleEditProfile.vue?vue&type=script&lang=js&"
export * from "./ModuleEditProfile.vue?vue&type=script&lang=js&"
import style0 from "./ModuleEditProfile.vue?vue&type=style&index=0&id=93fff466&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93fff466",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VTextField,VTextarea})
